import { render, staticRenderFns } from "./PreviewFullTopic.vue?vue&type=template&id=c24554d6&"
import script from "./PreviewFullTopic.vue?vue&type=script&lang=js&"
export * from "./PreviewFullTopic.vue?vue&type=script&lang=js&"
import style0 from "./PreviewFullTopic.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports